import React, {useState, useEffect, useContext} from 'react'
import { Button, Input, Table, Image, Pagination, Dropdown, Menu, Grid, Icon, Form } from 'semantic-ui-react'
import { Col, Row } from 'react-flexbox-grid'
import UsersTableRow from './usersTableRow'
import { connect } from 'react-redux'
import { backendService } from '../../services/backendService'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import Logo from '../../images/logo-admin.png'
import { Text } from '../../helpers/language';

const options = [
  { key: 1, text: '10', value: 10 },
  { key: 2, text: '15', value: 15 },
  { key: 3, text: '20', value: 20 },
]

const UsersTable = (props) => {

  const statusOptions = [
    { key: 1, text: Text({tid:'admin_users_all'}), value: 'all' },
    { key: 2, text: Text({tid:'admin_users_email_not_verified'}), value: false },
    { key: 3, text: Text({tid:'admin_users_email_verified'}), value: true },
  ]

  const [users, setUsers] = useState([])
  const [offset, setOffset] = useState(1)
  const [pages, setPages] = useState(0)
  const [limit, setLimit] = useState(10)
  const [search, setSearch] = useState('')
  const [is_verified, setIsVerified] = useState('all')

  useEffect(() => {
    getUsers()
  }, [limit, offset, is_verified]);
  

  const getUsers = async() => {
    
    const response = await backendService.get('/api/lawyers',{ params: { limit, offset, is_verified, search} })
    if(response.data){
      setUsers(response.data.lawyers)
      setPages(response.data.pages)
      } else {
        //   this.setState({ error: 'Ops something went wrong fetching user information' })
      }
    }
    
    const rows = users.map(user => 
    <UsersTableRow key={user.id} user={user} getUsers={getUsers} /> )
  
    ////////////////////////////////////////
    const searchChange = (e) =>{
      setSearch(e.target.value)
    } 

    const handleSearch = (e) => {
      setLimit(10);
      setOffset(1);
      getUsers()
    }
    ////////////////////////////////////////

    const handleChangeLimit = (e, data) => {
      setLimit(data.value)
    }

    const handleChangePage = (e, data) => {
      setOffset(data.activePage)
    }

    const handleChangeStatus = (e, data) => {
      setIsVerified(data.value)
    }

    return (
    <div>
      <Col xs={10} sm={4} md={3} className='lisia-app-logo-wrapper'>
        <Link to='/'>
          <Image src={ Logo } />
        </Link>
      </Col>
      <div style={{width:'80%', margin: '0 auto'}}>
        <Grid stretched stackable columns={2} verticalAlign='top' style={{justifyContent: 'space-between', marginLeft: '0px'}} >
          <Grid.Row>
            <Grid.Column width={7} style={{flexDirection: 'inherit'}}>
            <Form onSubmit={handleSearch} >
              <Input
                style={{width: '80%'}}
                icon={<Icon className='search' circular />}
                placeholder={Text({tid:'admin_users_search'})}
                onChange={searchChange}
              />
            </Form>
            <Dropdown
              style={{width: '20%'}}
              value={is_verified}
              fluid
              selection
              options={statusOptions}
              onChange={handleChangeStatus}
            />
            </Grid.Column>
            <Grid.Column width={3}>
              <Link to='/createuser'>
                <Button
                    icon 
                    labelPosition='right'
                    className='lisia-blue' style={{float: 'right', marginBottom: '14px'}}>
                  <Text tid='add_user' />
                  <Icon name='add'/>
                </Button>
              </Link>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <div className='sidescroll'>
        <Table celled unstackable >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="single line center aligned"><Text tid='admin_user_profile_first_name' /></Table.HeaderCell>
              <Table.HeaderCell className="center aligned"><Text tid='admin_user_profile_last_name' /></Table.HeaderCell>
              <Table.HeaderCell className="center aligned"><Text tid='admin_user_profile_email' /></Table.HeaderCell>
              <Table.HeaderCell className="center aligned"><Text tid='admin_usesr_profile_verified_email' /></Table.HeaderCell>
              <Table.HeaderCell className="center aligned"><Text tid='user_profile_license_expiration' /></Table.HeaderCell>
              <Table.HeaderCell className="center aligned"><Text tid='user_profile_registration_date' /></Table.HeaderCell>
              <Table.HeaderCell className="center aligned"><Text tid='user_profile_actions' /></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body className='adminsTable'>
            {rows}
          </Table.Body>
          <Table.Footer>
          </Table.Footer>
        </Table>
        </div>
        <Menu compact>
        <Dropdown
          value={limit}
          fluid
          selection
          options={options}
          onChange={handleChangeLimit}
        />
        </Menu>
          <Pagination 
            defaultActivePage={1}             
            boundaryRange={1} 
            totalPages={pages}
            onPageChange={handleChangePage}
            prevItem={null}
            nextItem={null}
          />
      </div>
    </div>
      )
}
const mapStateToProps = (state) => ({
  auth: state.auth,
  users: state.users
})
const mapDispatchToProps = {}

export default connect(mapStateToProps)(UsersTable)

